var $5505a1ca71ffd6f4$exports = {};
$5505a1ca71ffd6f4$exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Obri\u{161}i da biste uklonili oznaku.`
};


export {$5505a1ca71ffd6f4$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
